import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	background: ${colors.white};
	color: ${colors.grey7};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 24px 32px;
	margin-bottom: 32px;
	border-radius: 1px;
	position: relative;
	box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
`;

export const HorizontalLine = styled.div`
	position: absolute;
	right: 0;
	left: 0;
	top: 103px;
	height: 1px;
	background: ${colors.grey3};
`;

export const Title = styled.div`
	font-size: 19px;
	font-weight: 500;
	line-height: 27px;
	letter-spacing: 0px;
	margin-bottom: 25px;
`;

export const Table = styled.div`
	font-size: 13px;
	display: grid;
	grid-template-columns: 312px 160px repeat(
			${({ colsCount }) => colsCount - 2},
			1fr
		);
	position: relative;
`;

const cellStyle = css`
	display: flex;
	flex-direction: row;
	padding-right: 16px;
	justify-content: right;
	white-space: nowrap;

	&:first-child,
	&:nth-child(-n + 3) {
		justify-content: left;
	}
`;

export const TableCell = styled.div`
	color: ${colors.grey8};
	height: 40px;

	${cellStyle};
	align-items: center;

	&:first-child {
		padding-left: 32px;
		margin-left: -32px;
	}
	&:last-child {
		padding-right: 48px;
		margin-right: -32px;
	}

	${({ isRelative }) => isRelative && 'position: relative;'};
`;

export const TooltipIcon = styled.div`
	position: absolute;
	visibility: visible;

	top: 11px;
	left: 8px;

	svg {
		transition: none;
	}

	${({ isHidden }) => isHidden && 'visibility: hidden;'};
`;

export const TooltipContent = styled.div`
	text-align: left;
	padding: 8px;
`;

export const InnerCellWrapper = styled.div`
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const SpendTableCell = styled(TableCell)`
	padding-right: 2px;
	& span {
		padding-right: 8px;
	}
`;

export const TableHeaderCell = styled.div`
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	height: 28px;
	color: ${colors.grey5};
	cursor: default;
	user-select: none;

	.ap-icon {
		margin: -4px -18px 0 2px;
	}

	&:nth-child(4) {
		padding-right: 28px;
	}

	${cellStyle};
`;

export const TableRow = styled.div`
	display: contents;

	${({ isHovered }) =>
		isHovered
			? css`
					& ${TableCell} {
						background: ${colors.grey1};
					}
			  `
			: ''};
`;

export const MenuWrapper = styled.div`
	position: absolute;
	top: ${props => props.top || 0}px;
	right: -16px;
	width: 32px;
	height: 32px;
`;
